import { combineReducers } from 'redux';
import {
} from '../constants/GlobalArtistsSearchConstants';

const GlobalArtistsSearchReducer = () => {}

export default GlobalArtistsSearchReducer;
